import { Component } from "vue";
import _ from "lodash";

import { createComponent, createElement as h } from "@vue/composition-api";
import { FormItem } from "element-ui";

// TODO remove 'defaultValue' param
export function formField(inputComponent: Component, defaultValue: any = null) {
  return createComponent({
    name: (inputComponent.name || "Anonymous") + "FormField",
    inheritAttrs: false,
    props: {
      label: { type: String, required: false },
      value: { required: true },
      error: { required: false },
    },
    setup(props, ctx) {
      return () =>
        h(
          FormItem,
          { props: { prop: ctx.attrs["name"], error: props.error } },
          [
            h(
              "span",
              {
                slot: "label",
              },
              [props.label],
            ),
            h(inputComponent, {
              attrs: ctx.attrs,
              on: ctx.listeners,
              props: {
                value: props.value,
                ...ctx.attrs,
              },
            }),
          ],
        );
    },
  });
}
